import Image from 'next/image';

import { akamaiLoader } from '@/utils/akamaiLoader';

import type { ProductTypeOptions } from '@/lib/product';
import { getProductPlaceholderImage } from '@/lib/product';
import { generateDataTestId } from '@/lib/tests';
import type { WithHTMLProp } from '@/lib/types';

import * as S from './ImagePlaceholder.styles';

export interface ImagePlaceholderProps extends WithHTMLProp<'className'> {
  productType?: ProductTypeOptions;
  sizes?: string;
  withBackground?: boolean;
}

export const ImagePlaceholder = ({
  className,
  productType,
  sizes = '100vw',
  withBackground = true,
}: ImagePlaceholderProps) => {
  const placeholderImage = getProductPlaceholderImage(productType);

  return (
    <S.Placeholder
      className={className}
      data-test-id='ImagePlaceholderPlaceholder'
      withBackground={withBackground}
      {...generateDataTestId('image', 'placeholder')}
    >
      {placeholderImage ? (
        <Image
          alt={`${productType} placeholder`}
          data-testid='ImagePlaceholderLogo'
          height={0}
          loader={akamaiLoader}
          sizes={sizes}
          src={placeholderImage}
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            maxHeight: '100%',
          }}
          width={0}
        />
      ) : (
        <S.Logo data-testid='ImagePlaceholderLogo' />
      )}
    </S.Placeholder>
  );
};

ImagePlaceholder.displayName = 'ImagePlaceholder';
